import React from "react";
import { auth } from "../utils/firebase";
import { useNavigate } from "react-router-dom";

export default function LogOutButton() {
  const navigate = useNavigate();
  return (
    <button
      className="btn btn-warning"
      onClick={() => {
        localStorage.clear();
        auth.signOut();
        navigate("/");
      }}
      style={{ marginTop: 16, fontSize: 20 }}
    >
      LOGOUT
    </button>
  );
}
